module.exports = __webpack_public_path__ + "img/document.aa7ccd54.svg";